// extracted by mini-css-extract-plugin
module.exports = {"root":"NavTag_root__a0ZWZ","rotation":"NavTag_rotation__jJncY"};